module.exports = __webpack_public_path__ + "aeed4b60e9cf90294c257b707e3bb85a.jpg";